import { render, staticRenderFns } from "./ViewOld.vue?vue&type=template&id=49cbd0e2&scoped=true"
import script from "./ViewOld.vue?vue&type=script&lang=js"
export * from "./ViewOld.vue?vue&type=script&lang=js"
import style0 from "./ViewOld.vue?vue&type=style&index=0&id=49cbd0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cbd0e2",
  null
  
)

export default component.exports